<!-- Contact Component -->
<script>
	import { Col, Row, Container, FormGroup, Input } from "sveltestrap";
	import * as yup from 'yup';

	const regSchema = yup.object().shape({
		name: yup.string().required(),
		email: yup.string().required().email(),
		subject: yup.string().required(),
		comments: yup.string().required(),
	});

	export { regSchema };
  
</script>
  
  <!-- CONTACT FORM START-->
  <section class="section common-section" id="contact">
	<Container>
	  <Row>
		<Col lg={{ size: 8, offset: 2 }}>
		  <h1 class="section-title text-center">Contact Us</h1>
		  <div class="section-title-border mt-3" />
		  <p class="section-subtitle text-muted text-center font-secondary pt-4">
			We look forward to hearing from you and will do everything in our power to get back to you promptly.
		  </p>
		</Col>
	  </Row>
	  <Row>
		<Col lg="4">
		  <div class="mt-4 pt-4">
			<p class="mt-4">
			  <span class="h5">Areas we service:</span><br />
			  <span class="text-muted d-block mt-2"
				>Northern NJ</span
			  >
			</p>
			<p class="mt-4">
			  <span class="h5">How to reach us:</span><br />
			  <span class="text-muted d-block mt-2">Using this form is the best way to reach us.  We will get back to you in short order!</span>
			</p>
		  </div>
		</Col>
		<Col lg="8">
		  <div class="custom-form mt-4 pt-4">
			<form method="post" name="myForm" onsubmit="return validateForm()">
			  <p id="error-msg" />
			  <div id="simple-msg" />
			  <Row>
				<Col lg="6">
				  <FormGroup class="mt-2">
					<Input
					  name="name"
					  id="name"
					  type="text"
					  class="form-control"
					  placeholder="Your name*"
					/>
				  </FormGroup>
				</Col>
				<Col lg="6">
				  <FormGroup class="mt-2">
					<Input
					  name="email"
					  id="email"
					  type="email"
					  class="form-control"
					  placeholder="Your email*"
					/>
				  </FormGroup>
				</Col>
			  </Row>
			  <Row>
				<Col lg="12">
				  <FormGroup class="mt-2">
					<Input
					  type="text"
					  class="form-control"
					  id="subject"
					  name="subject"
					  placeholder="Your Subject.."
					/>
				  </FormGroup>
				</Col>
			  </Row>
			  <Row>
				<Col lg="12">
				  <FormGroup class="mt-2">
					<Input
					  type="textarea"
					  name="comments"
					  id="comments"
					  rows="4"
					  class="form-control"
					  placeholder="Your message..."
					/>
				  </FormGroup>
				</Col>
			  </Row>
			  <Row>
				<Col lg="12" class="text-end">
				  <Input
					type="submit"
					id="submit"
					name="send"
					class="submitBnt btn btn-primary"
					value="Send Message"
				  />
				</Col>
			  </Row>
			</form>
		  </div>
		</Col>
	  </Row>
	</Container>
  </section>
  <!-- CONTACT FORM END-->
  
  <!--START SOCIAL-->
  <section class="contact-social bg-light">
	<Container>
	  <Row class="align-items-center">
		<!-- <Col lg="6">
		  <ul class="list-inline social mt-4">
			<li class="list-inline-item">
			  <a href={"#"} class="social-icon"><i class="mdi mdi-facebook" /></a>
			</li>
			<li class="list-inline-item">
			  <a href={"#"} class="social-icon"><i class="mdi mdi-twitter" /></a>
			</li>
			<li class="list-inline-item">
			  <a href={"#"} class="social-icon"><i class="mdi mdi-linkedin" /></a>
			</li>
			<li class="list-inline-item">
			  <a href={"#"} class="social-icon"
				><i class="mdi mdi-google-plus" /></a
			  >
			</li>
			<li class="list-inline-item">
			  <a href={"#"} class="social-icon"><i class="mdi mdi-dribbble" /></a>
			</li>
		  </ul>
		</Col> -->
		<Col lg="6" class="mt-4">
		  <!-- <p class="contact-title">
			<i class="pe-7s-call" /> &nbsp;(201)555-1212
		  </p> -->
		</Col>
		<Col lg="6" class="mt-4 text-end">
		  <p class="contact-title">
			<i class="pe-7s-mail-open" />&nbsp; allaxishomeinspections@gmail.com
		  </p>
		</Col>
	  </Row>
	</Container>
  </section>
  <!--END SOCIAL-->
  